module.exports = __webpack_public_path__ + "static/img/jf2.b2ea4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/jf2.png
// module id = vC0n
// module chunks = 11